/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { compose } from 'recompose';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import { MetaNavigation, isMetaNavEnabled } from 'bundles/ent-website/components/MetaNavigation';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import HeaderLogo from 'bundles/page-header/components/HeaderLogo';
import UnauthenticatedAccountInfo from 'bundles/page-header/components/UnauthenticatedAccountInfo';
import MegaMenuWrapper from 'bundles/page-header/components/desktop/mega-menu/MegaMenuWrapperLite';
import MegaMenu from 'bundles/page-header/components/optimized/MegaMenuContent';
import SearchBar from 'bundles/page-header/components/optimized/SearchBar';
import PageNavigationL1 from 'bundles/page-header/components/page-navigation/PageNavigationL1';
import withDesktopBanners from 'bundles/page-header/hoc/withDesktopBanners';
import useUserAgent from 'bundles/page/hooks/useUserAgent';
import { getShowNewMegamenu as isShowNewMegamenu } from 'bundles/search-common/utils/experimentUtils';

type Props = {
  isFrontPage?: boolean;
  isStandaloneAuth?: boolean;
  isSearchPage?: boolean;
  logoWrapper?: string;
  hideRightNav?: boolean;
  hideSearch?: boolean;
};

export const styles = {
  col: css`
    display: flex;
    align-items: center;
    width: 50%;
    position: relative;
    min-height: 1px;
    padding-left: 12px;
    padding-right: 12px;
  `,
  unifiedLogo: css`
    .rc-HeaderLogo {
      margin-right: 0;
    }
  `,
};

export const LoggedOutDesktopHeader = ({
  isFrontPage,
  isSearchPage,
  logoWrapper,
  hideSearch,
  hideRightNav,
  isStandaloneAuth,
}: Props) => {
  const userAgent = useUserAgent();
  const metaNavEnabled = isMetaNavEnabled();

  const content = (
    <div className={'rc-LoggedOutDesktopHeader context-header--unified'}>
      <div className="context-header__child" css={styles.col}>
        <div css={styles.unifiedLogo}>
          <HeaderLogo hexColorCode="#2A73CC" logoWrapper={logoWrapper} />
        </div>
        {!hideSearch && (
          <React.Fragment>
            {isShowNewMegamenu() ? (
              <SimplifiedMegaMenuWrapper />
            ) : (
              <MegaMenuWrapper
                LoadableMegaMenu={MegaMenu}
                // Menu on front page needs to be in server response for SEO reasons.
                renderMenuOnServer={isFrontPage}
              />
            )}
            <SearchBar isSearchPage={isSearchPage} />
          </React.Fragment>
        )}
      </div>
      <div className="context-header__child context-header__child--right" css={styles.col}>
        {!hideRightNav && (
          <React.Fragment>
            {!userAgent?.isOculusQuest && <PageNavigationL1 />}
            <UnauthenticatedAccountInfo
              className="c-navbar-list bt3-nav bt3-navbar-nav"
              isStandaloneAuth={isStandaloneAuth}
              isFrontPage={isFrontPage}
              // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
              id="unauthenticated-info-menu"
              hideEnterprise={userAgent?.isOculusQuest}
            />
          </React.Fragment>
        )}
      </div>
    </div>
  );

  return (
    <>
      {metaNavEnabled && <MetaNavigation />}
      <PageGridContainer>
        <Grid xs={12} item>
          {content}
        </Grid>
      </PageGridContainer>
    </>
  );
};

export default compose<Props, Props>(withDesktopBanners)(LoggedOutDesktopHeader);
